function RequestedStatus() {
  return (
    <div className="w-[84px] h-[22px] flex items-center justify-center rounded-[11px] bg-[#E6E7EC] font-OpenSansRegular font-[400] text-titleColor text-[10px]">
      REQUESTED
    </div>
  );
}

export default RequestedStatus;
